export const isVendorChargePaid = (accessorialId = '', vendorPayables = []) => {
    if (vendorPayables === null || vendorPayables === void 0 ? void 0 : vendorPayables.length) {
        const vendorCharge = vendorPayables.find((charge) => (charge === null || charge === void 0 ? void 0 : charge.accessorial_request_id) === accessorialId);
        if (vendorCharge) {
            return (vendorCharge === null || vendorCharge === void 0 ? void 0 : vendorCharge.payment_status) === 'paid';
        }
    }
    return false;
};
